// extracted by mini-css-extract-plugin
export default {"root":"Shop_root__j3JXn","controls":"Shop_controls__mw+xL"};